// services/vatKey.js — ДДС номерът на контакта като ключ за ВИЕС (ПРОМТ-36).
//
// Отделен, чист модул, защото го ползват и сървърът (services/bulkCheck.js),
// и екранът на контактите (значката „ДДС № невалиден"): значката важи само
// докато номерът в контакта е същият, проверения. Две нормализирания биха се
// разминали рано или късно — същият урок като normalizeId.

// Държавите, които ВИЕС познава (Гърция е EL; XI — Северна Ирландия).
const VIES_COUNTRIES = new Set(['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'EL', 'ES', 'FI', 'FR', 'HR', 'HU',
  'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'XI']);
const ISO_TO_VIES = { GR: 'EL' };

// ДДС номерът на контакта → { cc, num, key } или null. Само цифри без
// представка = номер от държавата на контакта (празна = BG): „123456789" →
// BG123456789. Държава извън ВИЕС (CH, GB…) няма какво да се пита.
function vatKey(vat, country) {
  let s = String(vat || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
  if (!s) return null;
  let cc;
  if (/^[A-Z]{2}/.test(s)) { cc = s.slice(0, 2); s = s.slice(2); }
  else cc = String(country || '').toUpperCase().trim() || 'BG';
  cc = ISO_TO_VIES[cc] || cc;
  if (!VIES_COUNTRIES.has(cc)) return null;
  if (!/^[0-9A-Z]{2,14}$/.test(s)) return null;
  if (cc === 'BG' && !/^\d{9,10}$/.test(s)) return null;
  return { cc, num: s, key: cc + s };
}

// Ключът на контакта: ДДС номерът, а без него — BG + ЕИК (регистрираните по
// ЗДДС са с ДДС № = BG + ЕИК). Физическите лица не се проверяват.
function contactKey(c) {
  if (!c || c.is_person) return null;
  const v = vatKey(c.vat_number, c.country);
  if (v) return Object.assign(v, { source: 'vat' });
  const country = String(c.country || 'BG').toUpperCase();
  const eik = String(c.eik || '').replace(/\D/g, '');
  if (country === 'BG' && /^\d{9}$/.test(eik)) return { cc: 'BG', num: eik, key: 'BG' + eik, source: 'eik' };
  return null;
}

module.exports = { VIES_COUNTRIES, vatKey, contactKey };
